import React from 'react';
import { Placeholder } from '@sitecore-jss/sitecore-jss-react';
import { SitecoreContextReactContext } from '../../../utils/SitecoreContextReactContext';
var CommonPageContainer = function CommonPageContainer(_ref) {
  var rendering = _ref.rendering,
    params = _ref.params,
    route = _ref.route;
  var _React$useContext = React.useContext(SitecoreContextReactContext),
    pageEditing = _React$useContext.pageEditing;
  var bodyPlaceholderName = params && params.bodyPlaceholderName || rendering.placeholders && Object.keys(rendering.placeholders)[0];
  if (!bodyPlaceholderName) {
    throw new Error('No placeholders assigned to CommonPageContainer');
  }
  if (pageEditing) {
    return /*#__PURE__*/React.createElement("div", {
      className: "p-5"
    }, /*#__PURE__*/React.createElement(Placeholder, {
      name: bodyPlaceholderName,
      rendering: rendering,
      route: route
    }));
  }
  return /*#__PURE__*/React.createElement(Placeholder, {
    name: bodyPlaceholderName,
    rendering: rendering,
    route: route
  });
};
export default CommonPageContainer;